// import { OrganizationJsonLd } from 'next-seo';
import Image from 'next/image';
import Link from 'next/link';
import { baseUrl } from '@/lib/constants';

export default function ContactFooter() {
  return (
    <>
      {/* <OrganizationJsonLd
        name={process.env.NEXT_PUBLIC_APP_NAME as string}
        url={baseUrl}
        logo={`${baseUrl}/static/icons/Logo.svg`}
        sameAs={[
          'https://www.linkedin.com/company/ahamove/',
          'https://www.facebook.com/AhamoveVietNam',
          'https://www.youtube.com/@ahamoveofficial6703',
          'https://www.tiktok.com/@ahamove.official',
        ]}
        address={{
          '@type': 'PostalAddress',
          streetAddress:
            'Tầng 1, Tòa nhà Rivera Park, 7/28 Thành Thái, Phường 14, Quận 10',
          addressRegion: 'Quận 10',
          addressLocality: 'Hồ Chí Minh',
          addressCountry: 'VN',
          postalCode: '700000',
        }}
        contactPoint={[
          {
            telephone: '1900545411',
            contactType: 'customer service',
            areaServed: ['VN', 'US'],
            availableLanguage: ['Vietnamese', 'English'],
            email: 'support@ahamove.com',
          },
        ]}
      /> */}
      <div className="desktop:space-y-6 space-y-4">
        <h2 className="text-subtitle18 desktop:text-title24 desktop:font-bold text-left font-semibold text-black">
          Công ty Cổ Phần Dịch Vụ Tức Thời
        </h2>
        <ul className="text-body14 desktop:space-y-3 desktop:text-body16 space-y-4 text-left font-medium text-black">
          <li>
            <Link
              href="https://maps.app.goo.gl/qGEUYFyacVRpWUXa8"
              className="hover:text-neutral-70 desktop:items-center flex space-x-3"
              title=""
            >
              <div className="relative inline-block h-5 w-5 shrink-0">
                <Image
                  src="/static/icons/LocationMarker.svg"
                  alt="VP TPHCM"
                  fill
                />
              </div>
              <p className="inline-block">
                VP TPHCM: Tầng 1, Tòa nhà Rivera Park, 7/28 Thành Thái, Phường
                14, Quận 10
              </p>
            </Link>
          </li>
          <li>
            <Link
              href="https://maps.app.goo.gl/umMcaL4gd1iNFx5H9"
              className="hover:text-neutral-70 desktop:items-center flex flex-nowrap space-x-3"
              title=""
            >
              <div className="relative inline-block h-5 w-5 shrink-0">
                <Image
                  src="/static/icons/LocationMarker.svg"
                  alt="VP Hà Nội"
                  fill
                />
              </div>
              <p className="inline-block">
                VP Hà Nội: Tầng 9, Tòa nhà Mipec, số 229 Tây Sơn, Phường Ngã Tư
                Sở, Quận Đống Đa
              </p>
            </Link>
          </li>
          <li>
            <Link
              href="https://maps.app.goo.gl/h4QiPE631GfVRM9F7"
              className="hover:text-neutral-70 desktop:items-center flex space-x-3"
              title=""
            >
              <div className="relative inline-block h-5 w-5 shrink-0">
                <Image
                  src="/static/icons/LocationMarker.svg"
                  alt="VP Đà Nẵng"
                  fill
                />
              </div>
              <p className="inline-block">
                VP Đà Nẵng: 66A Lê Đình Lý, Thanh Khê, Đà Nẵng
              </p>
            </Link>
          </li>
          <li>
            <Link
              href="mailto:support@ahamove.com"
              className="hover:text-neutral-70 desktop:items-center flex flex-nowrap space-x-3"
              title=""
            >
              <div className="relative inline-block h-5 w-5 shrink-0">
                <Image src="/static/icons/Mail.svg" alt="Email" fill />
              </div>
              <p className="inline-block">support@ahamove.com</p>
            </Link>
          </li>
          {/* <li>
            <Link
              href="tel:1900545411"
              className="hover:text-neutral-70 desktop:items-center flex flex-nowrap space-x-3"
              title=""
            >
              <div className="relative inline-block h-5 w-5 shrink-0">
                <Image src="/static/icons/Phone.svg" alt="Phone" fill />
              </div>
              <p className="inline-block">1900545411</p>
            </Link>
          </li> */}
        </ul>
      </div>
    </>
  );
}
